<template>
  <Login />
</template>

<script>
import Login from '@/components/login/LoginForm.vue'

export default {
  name: 'LoginPage',
  components: { Login }
}
</script>

<style scoped>

</style>
